var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "custom-toggle",
      class: [_vm.classes, { disabled: _vm.disabled }]
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.model,
            expression: "model"
          }
        ],
        attrs: { id: _vm.cbId, type: "checkbox", disabled: _vm.disabled },
        domProps: {
          value: _vm.value,
          checked: Array.isArray(_vm.model)
            ? _vm._i(_vm.model, _vm.value) > -1
            : _vm.model
        },
        on: {
          change: [
            function($event) {
              var $$a = _vm.model,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = _vm.value,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.model = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.model = $$c
              }
            },
            _vm.onChange
          ]
        }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "custom-toggle-slider rounded-circle" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }